import { default as BrightyPumpkinPng } from './brand/brighty/BrightyPumpkin.png';
import { default as BrightyPumpkinWebP } from './brand/brighty/BrightyPumpkin.webp';
import { default as BrightyPumpkinAvif } from './brand/brighty/BrightyPumpkin.avif';
import { ImageProps, image } from './image';

export function GraphicsPumpkinImage(props: ImageProps) {
  return __BRIGHTY__
    ? image(props, BrightyPumpkinPng, BrightyPumpkinWebP, BrightyPumpkinAvif)
    : null;
}
